import React, {useState} from "react";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import {selfcareChangeMobileConfirm, selfcareChangeMobileCancel} from "../../../util/request";
import {phoneNumber} from "../../../util/formatter";
import LoaderSpinner from "../../loaders/LoaderSpinner";

export default function ChangeMobileConfirm(props: {
    isChangingMobileTo: string,
    setIsChangingMobileTo: (v: string|null) => void,
    setShowChangeMobile: (v: boolean) => void,
    setMobileNo: (v: string) => void,
    setParentErrorMessage: (v: string|null) => void,
}) {
    const {customer} = useCustomer()
    const {isChangingMobileTo, setIsChangingMobileTo, setShowChangeMobile, setMobileNo, setParentErrorMessage} = props;

    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string|null>(null);
    const [successMessage, setSuccessMessage] = useState<string|null>(null);
    const [showForm, setShowForm] = useState<boolean>(true);
    const [secret, setSecret] = useState<string>('');

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        console.log('hest');
        event.preventDefault();
        console.log('pingu')

        setLoading(true);

        selfcareChangeMobileConfirm(customer.customer_id, secret).then(r => {
            if (r.code === 250) {
                setParentErrorMessage(
                    'Du har indtastet en forkert bekræftelseskode for mange gange, prøv at skifte nummeret igen.'
                );
                setShowForm(false);
                setIsChangingMobileTo(null);
                setShowChangeMobile(false);
                return;
            }
            if (r.code !== 200) {
                setErrorMessage('Du har indtastet en forkert bekræftelseskode. Prøv igen.');
                return;
            }
            setSuccessMessage('Sådan! Dit nye nummer blev bekræftet.');
            setShowForm(false);
            setIsChangingMobileTo(null);
            setShowChangeMobile(false);
            setMobileNo(r.response.data.mobile_new);

        }).catch(() => {
            setErrorMessage('Der skete desværre en fejl. Prøv igen.');
        }).finally(() => {
            setLoading(false);
        });
    };

    const abortChangingMobile = () => {
        selfcareChangeMobileCancel(customer.customer_id).then(r => {
            if (r.code !== 200) {
                setErrorMessage('Der skete desværre en fejl. Prøv igen.');
                return;
            }
            setSuccessMessage('Du annullerede skift af mobil');
            setShowForm(false);
            setIsChangingMobileTo(null);
            setShowChangeMobile(false);

        }).catch(() => {
            setErrorMessage('Der skete desværre en fejl. Prøv igen.');
        }).finally(() => {
            setLoading(false);
        });
    };

    return (
        <form className="selfcare-account-form visible" onSubmit={handleSubmit} onReset={abortChangingMobile}>
            {showForm && (
                <>
                    <p>
                        <input
                            type="text"
                            placeholder="Kode"
                            onChange={(e) => setSecret(e.target.value)}
                            required
                        />
                    </p>

                    {errorMessage && <p className="selfcare-message-error">{errorMessage}</p>}

                    <p className="selfcare-explainer-confirm">
                        Vi har sendt en bekræftelseskode til {phoneNumber(isChangingMobileTo)}.
                        Indtast koden her for at bekræfte ændringen.
                        <br/>
                        Hvis du har tastet forkert eller fortryder dit skifte af mobilnummer, så{' '}
                        <button type='reset' className='selfcare-button-link'>klik her</button>.
                    </p>

                    {loading ? <LoaderSpinner/> :
                        <p className="submit-button-block">
                            <label id="submit-form-button" className="button teal">
                                <input disabled={loading} className="continue-button-submit" type="submit"/>
                                <span className="text">Gem</span>
                            </label>
                        </p>
                    }
                </>
            )}

            {successMessage && <p className="selfcare-message-success">{successMessage}</p>}
        </form>
    )
}
